import { fixJson } from "./fixJson";

export const safelyParseJSON = data =>{
    let parsed;
    //console.log(data)

    try{
        parsed = JSON.parse(data)
    }catch(e){
        //parsed = JSON.parse(JSON.stringify(data))
        parsed = fixJson(JSON.parse(JSON.stringify(data)))
        //parsed = null
    }

    return parsed;
}